import authCheckApp from "./authCheckApp";

/**
 * 换起更新弹窗（webview）
 * @since 1.0.0
 * @example
 *
 * apiCheckAppUpdate()
 */
function apiSetupNav(data) {
  console.log(1723917293812937);
  authCheckApp()
    .then(() => {
      // 发起请求
      window.WebViewJavascriptBridge.callHandler(
        "apiSetupNav",
        data,
        response => {
          console.log(response, 123123123);
          return response;
        }
      );
    })
    .catch(err => {
      console.log(123131);
      console.log(err);
      Promise.reject(err);
    });
}

export default apiSetupNav;
